import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class MerchantGuard implements CanActivate {
  constructor(
    private router: Router,
    private auth: AuthService
  ) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.auth.currentUserValue;
    if (currentUser.user.role == 'Merchant' || currentUser.user.role == 'Administrator') {
        // logged in so return true
        return true;
    }

    // not logged in so redirect to login page with the return url
    this.auth.logout();
    this.router.navigate(['/login']);
    return false;
  }
  
}
